import { render } from "./TestimonialSlider.vue?vue&type=template&id=3591fd7c&scoped=true"
import script from "./TestimonialSlider.vue?vue&type=script&lang=js"
export * from "./TestimonialSlider.vue?vue&type=script&lang=js"

import "./TestimonialSlider.vue?vue&type=style&index=0&id=3591fd7c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3591fd7c"]])

export default __exports__